// extracted by mini-css-extract-plugin
export default {"wrapper":"PadYqPG2IuBXgiWZ580w","variables":"XknkwDtZriDGZJTliIX_","formulaScope":"OPNmeb_mQQh342CCBGWA"};